import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";

const styles = {
  cell: {
    border: "1px solid #000",
    padding: "4px",
    textAlign: "center",
    verticalAlign: "middle",
  },
};

function SAMPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>Materials and Methods</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              <strong>
                <em>
                  2.1 Study Area: Lakes in Hebbal-Nagavara Valley of Greater
                  Bangalore
                </em>
              </strong>
            </p>
            <p>
              Greater Bangalore (latitudes 12&deg;49'5' N and 13&deg;08'32" N,
              longitudes 77&deg;27'29" E and 77&deg;47'2" E), located at 920
              meters above sea level, has three watersheds:
              Koramangala-Challaghatta, Hebbal-Nagavara, and Vrishabhavathi. Due
              to the undulating topography of the Bangalore landscape, several
              tanks were built in the early 18<sup>th</sup> century to meet
              water requirements for irrigation and domestic purposes, apart
              from fishing and washing. The open-source GIS software QGIS
              (https://qgis.org) was used for spatial analyses, and Figure 1
              depicts the distribution of monitored lakes in the Hebbal-Nagavara
              Valley, Greater Bangalore.
            </p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/mu1.png" alt="" />{" "}
            </p>
            <table>
              <tbody>
                <tr>
                  <td width="656">
                    <p style={{ textAlign: "center" }}>
                      <strong>Figure 1: </strong>The map depicts the urban lakes
                      in the Hebbal-Nagavara Valley, Bangalore.
                    </p>
                    <p>Source: Authors</p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>
              <a name="_Toc20988617"></a>
              <strong>
                <em>2.2 Sample Collection and Analyses</em>
              </strong>
            </p>
            <p>
              Field investigations were carried out during 2018&ndash;2020, and
              water samples were collected in disinfected water sampling
              containers at inlets and outlets of lakes in the Hebbal-Nagavara
              Valley. Physicochemical parameters such as water temperature,
              dissolved oxygen, pH, total dissolved solids, electrical
              conductivity, turbidity, chloride, total hardness, calcium,
              magnesium, total alkalinity, chemical oxygen demand, biochemical
              oxygen demand, nitrate, and orthophosphate were estimated using
              the standard protocol (APHA,2012).
            </p>
            <p>
              Microalgae were collected by filtering 50 liters of lake surface
              water with a plankton net. Microalgae samples were fixed in a 4%
              Lugol iodine solution and concentrated to 50 mL. The samples were
              labeled and preserved in plastic bottles before being taken to the
              laboratory for taxonomic study. Microalgae samples were identified
              and counted using standard keys using an optical microscope
              (Olympus) (Desikachary,1959; Prescott,1970; Guiry &amp;
              Guiry,2023).
            </p>
            <p>
              <strong>
                <em>2.3 Statistical Analysis</em>
              </strong>
            </p>
            <p>
              PAST software (https://past.en.lo4d.com/windows) was used to
              compute microalgae diversity, diversity indices (such as the
              Shannon-Weaner diversity index, Simpson diversity index),
              Dominance index, Pielou Evenness index, and cluster analysis.
            </p>
            <br />
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default SAMPage;
